// Ödeme Entegrasyonu Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'integrations.editPayment';

export const editPaymentIntegrationModalGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ödeme entegrasyonu nasıl düzenlenir?'),
  intro: t(`${G}.intro`, 'Kayıtlı bir ödeme sağlayıcısının şubesini, durumunu ve kimlik bilgilerini burada güncellersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ödeme Entegrasyonu Düzenle'),
    body: t(`${G}.regions.body`, 'Şube, durum ve sağlayıcı bilgileri'),
    footer: t(`${G}.regions.footer`, 'İptal / Güncelle'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kaydı kontrol edin'),
      text: t(`${G}.s1.text`, 'Başlıktaki etiket kaydın sağlayıcısını gösterir (ör. PAYTR, MOKA); sağlayıcı sonradan değiştirilemez, gerekirse yeni kayıt ekleyin. Pencere açılınca kayıtlı bilgiler alanlara doldurulur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Şube ve durum'),
      text: t(`${G}.s2.text`, '"Şube" boş bırakılırsa kayıt şirket geneli olur. Aynı sağlayıcının o şubede (ya da şirket genelinde) başka kaydı varsa değişiklik reddedilir. "Aktif" kapalıyken kayıt ödemelerde kullanılmaz; "Test Modu" sağlayıcının test ortamına bağlanır; "3D Secure" kart doğrulamasını açar (Tacreo Kart\'ta yoktur).'),
      tips: [
        t(`${G}.s2.tip1`, 'Moka\'da Test Modu açıkken test bilgisi kullanın; canlı DealerCode ile açık bırakılırsa Moka "bayi bulunamadı" döner.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kimlik bilgilerini güncelleyin'),
      text: t(`${G}.s3.text`, 'Alanlar ekleme penceresindekiyle aynıdır ve zorunluluklar aynıdır: PayTR\'de Merchant ID / Key / Salt, Moka\'da DealerCode / Username / Password, Tacreo Kart\'ta Affiliate Id ve Hash. Gizli alanları göz simgesiyle görünür yapabilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'PayTR "Kayıtlı Site Adresi"ni boşaltıp güncellerseniz kayıtlı site adresi kaldırılır.'),
        t(`${G}.s3.tip2`, 'Moka\'nın taksit, vade farkı ve kart formu ayarları bu pencereden değişmez, güncellemede korunur; onları E-Ticaret > Ödeme (Moka) Ayarları bölümünden yönetin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Moka: banka taksit oranları'),
      text: t(`${G}.s4.text`, 'Moka kayıtlarında "Banka taksit oranlarını getir" düğmesi, Moka bayi hesabınızda tanımlı komisyon oranlarını banka ve kart programına göre Peşin ve 2–12 taksit sütunlarıyla gösterir. Boş hücre o taksitin ilgili kart programında kapalı olduğu anlamına gelir. Bu tablo yalnız bilgi içindir; burada oran değiştirilmez.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Güncelleyin'),
      text: t(`${G}.s5.text`, '"Güncelle" değişiklikleri kaydeder; başarılı olunca pencere kapanır ve liste yenilenir. Eksik zorunlu alan veya reddedilen değişiklik kırmızı kutuda yazar.'),
    },
  ],
});
